module.exports = __webpack_public_path__ + "resources/chat_cover.d3a0ce34dfe81b16.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-rcmd/img/chat_cover.png
// module id = 752
// module chunks = 0 2